import Animate from './animate';
import Expand from './expand';
Animate.Expand = Expand;
export default Animate;